import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Button, Layer, Text, Box, Anchor } from 'grommet';
import { FormClose, FormNext } from 'grommet-icons';

import { TitleDetail, Statistic } from '../../../../components/detail';

import { toggleInsightsLayer } from '../../actions/insights';

import visibleWidth from '../../../../constants/layer-width';

//import { formattedCurrency } from '../../../../utils';

const InsightsAmendment = (props) => {
  //const [selectedYear, setSelectedYear] = useState(2023);
  const [preview, setPreview] = useState('general'); // general, territorial, profile

  const {
    // id,

    toggleLayer,
    //loadingPostForm,
    toggleInsightsLayer,
  } = props;


  if(!toggleLayer || toggleLayer !== 'insights') {
    return null;
  }

  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Layer
          responsive={false}
          full='vertical'
          position='left'
          onClickOutside={toggleInsightsLayer}
          onEsc={toggleInsightsLayer}
        >
          <Box
            fill='vertical'
            width={visibleWidth[size]}
            pad={{ top: 'large', bottom: 'xsmall' }}
            overflow='auto'
            flex
          >
            <Box
              direction='row'
              justify='between'
              align='baseline'
              margin={{ horizontal: 'large' }}
            >
              <TitleDetail value='Estatísticas' />

              <Button
                plain
                title='Fechar'
                icon={<FormClose />}
                onClick={toggleInsightsLayer}
              />
            </Box>


            <Box flex overflow='auto'>

              {preview === 'general' && (
                <>
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    margin={{ vertical: 'small', horizontal: 'large' }}
                    flex={{ shrink: 0 }}
                  >
                    <Box
                      direction='row'
                      gap='small'
                    >
                      {/* Pessoas cadastradas */}
                      <Box
                        round='small'
                        width={{ min: 'small', max: 'small' }}
                        pad={{
                          vertical: size === 'small' ? 'large' : 'medium',
                          horizontal: size === 'small' ? 'large' : 'medium',
                        }}
                        border={{ color: 'light-4' }}
                        margin={{ bottom: 'small' }}
                      >
                        <Box
                          direction='row'
                          align='end'
                          gap='small'
                        >
                          <Text color='dark-1' size='large'>4.000</Text>
                        </Box>

                        <Box
                          direction='row'
                          justify='between'
                          align='center'
                          gap='small'
                        >
                          <Text truncate title='Total de pessoas cadastradas' size='small' color='dark-6'>Total de pessoas cadastradas</Text>
                        </Box>
                      </Box>

                      {/* Voto a conquistar ou perdido */}
                      <Box
                        round='small'
                        width={{ min: 'small', max: 'small' }}
                        pad={{
                          vertical: size === 'small' ? 'large' : 'medium',
                          horizontal: size === 'small' ? 'large' : 'medium',
                        }}
                        border={{ color: 'light-4' }}
                        margin={{ bottom: 'small' }}
                      >
                        <Box
                          direction='row'
                          align='end'
                          gap='small'
                        >
                          <Text color='status-warning' size='large'>3.000</Text>
                          <Text  color='status-warning' size='small'>90%</Text>
                        </Box>

                        <Box
                          direction='row'
                          justify='between'
                          align='center'
                          gap='small'
                        >
                          <Text truncate title='Votos a conquistar' size='small' color='dark-6'>Votos a conquistar</Text>
                        </Box>
                      </Box>

                      {/* Voto perdido */}
                      <Box
                        round='small'
                        width={{ min: 'small', max: 'small' }}
                        pad={{
                          vertical: size === 'small' ? 'large' : 'medium',
                          horizontal: size === 'small' ? 'large' : 'medium',
                        }}
                        border={{ color: 'light-4' }}
                        margin={{ bottom: 'small' }}
                      >
                        <Box
                          direction='row'
                          align='end'
                          gap='small'
                        >
                          <Text color='status-critical' size='large'>3.000</Text>
                          <Text  color='status-critical' size='small'>90%</Text>
                        </Box>

                        <Box
                          direction='row'
                          justify='between'
                          align='center'
                          gap='small'
                        >
                          <Text truncate title='Votos perdidos' size='small' color='dark-6'>Votos perdidos</Text>
                        </Box>
                      </Box>
                    </Box>
                  </Box>



                  {/* Força territórial */}
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    margin={{ vertical: 'small', horizontal: 'large' }}
                    flex={{ shrink: 0 }}
                  >
                    <Box
                      direction='row'
                      justify='between'
                      align='center'
                    >
                      <Box>
                        <Text color='dark-2' size='medium'>Força territorial</Text>
                        <Text color='dark-6' size='small'>Acompanhe os dados por bairro, cidade e estado.</Text>
                      </Box>

                      <Anchor
                        icon={ <FormNext color='dark-3' />}
                        onClick={() => {
                          setPreview('territorial');
                        }}
                      />
                    </Box>
                  </Box>

                  {/* Top 5 bairros número de cadastros com maior voto confirmado */}
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    margin={{ vertical: 'small', horizontal: 'large' }}
                    flex={{ shrink: 0 }}
                  >
                    <Box
                      border={ { color: 'light-5', size: 'xsmall' } }
                      pad={{ horizontal: 'medium', vertical: 'medium' }}
                      round='small'
                      gap='small'
                    >
                      <Text color='dark-2' size='medium'>Bairros com maior número de cadastros e voto confirmado</Text>

                      <Statistic
                        key={0}
                        title='Remanso Campineiro . Hortolândia'
                        graph={{
                          value: 1000 / 2400.90,
                          color: '#9f2d47ff',
                        }}
                        label={{
                          value: 1000,
                          formatter: 'decimal',
                          precision: 0,
                        }}
                      />

                      <Statistic
                        key={1}
                        title='Jardim Amanda . Hortolândia'
                        graph={{
                          value: 1500 / 2400.90,
                          color: '#DD7033',
                        }}
                        label={{
                          value: 1500,
                          formatter: 'decimal',
                          precision: 0,
                        }}
                      />

                      <Statistic
                        key={1}
                        title='Nova Hortolândia . Hortolândia'
                        graph={{
                          value: 1230 / 2400.90,
                          color: '#45922dff',
                        }}
                        label={{
                          value: 1230,
                          formatter: 'decimal',
                          precision: 0,
                        }}
                      />
                    </Box>
                  </Box>

                  {/* Top 5 Cidades número de cadastros com maior voto confirmado */}
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    margin={{ vertical: 'small', horizontal: 'large' }}
                    flex={{ shrink: 0 }}
                  >
                    <Box
                      border={ { color: 'light-5', size: 'xsmall' } }
                      pad={{ horizontal: 'medium', vertical: 'medium' }}
                      round='small'
                      gap='small'
                    >
                      <Text color='dark-2' size='medium'>Cidades com maior número de cadastros e voto confirmado</Text>

                      <Statistic
                        key={0}
                        title='Hortolândia. SP'
                        graph={{
                          value: 1000 / 2400.90,
                          color: '#9f2d47ff',
                        }}
                        label={{
                          value: 1000,
                          formatter: 'decimal',
                          precision: 0,
                        }}
                      />

                      <Statistic
                        key={1}
                        title='Campinas . SP'
                        graph={{
                          value: 1500 / 2400.90,
                          color: '#DD7033',
                        }}
                        label={{
                          value: 1500,
                          formatter: 'decimal',
                          precision: 0,
                        }}
                      />
                    </Box>
                  </Box>



                  {/* Perfil do eleitor */}
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    margin={{ vertical: 'small', horizontal: 'large' }}
                    flex={{ shrink: 0 }}
                  >
                    <Box
                      direction='row'
                      justify='between'
                      align='center'
                    >
                      <Box>
                        <Text color='dark-2' size='medium'>Perfil do eleitor</Text>
                        <Text color='dark-6' size='small'>Acompanhe os dados por por faixa de idade, gênero e mais...</Text>
                      </Box>

                      <Anchor
                        icon={ <FormNext color='dark-3' />}
                        onClick={() => { }}
                      />
                    </Box>
                  </Box>


                  {/* Faixa etária */}
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    margin={{ vertical: 'small', horizontal: 'large' }}
                    flex={{ shrink: 0 }}
                  >
                    <Box
                      border={ { color: 'light-5', size: 'xsmall' } }
                      pad={{ horizontal: 'medium', vertical: 'medium' }}
                      round='small'
                      gap='small'
                    >
                      <Text color='dark-2' size='medium'>Faixa etária</Text>

                      <Statistic
                        key={0}
                        title='0 - 18 anos'
                        graph={{
                          value: 2000 / 2400.90,
                          color: '#64C680',
                        }}
                        label={{
                          value: 2000,
                          formatter: 'decimal',
                          precision: 0,
                        }}
                      />

                      <Statistic
                        key={1}
                        title='19 - 30 anos'
                        graph={{
                          value: 200 / 2400.90,
                          color: '#DD7033',
                        }}
                        label={{
                          value: 200,
                          formatter: 'decimal',
                          precision: 0,
                        }}
                      />
                    </Box>
                  </Box>

                  {/* Gênero */}
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    margin={{ vertical: 'small', horizontal: 'large' }}
                    flex={{ shrink: 0 }}
                  >
                    <Box
                      border={ { color: 'light-5', size: 'xsmall' } }
                      pad={{ horizontal: 'medium', vertical: 'medium' }}
                      round='small'
                      gap='small'
                    >
                      <Text color='dark-2' size='medium'>Gênero</Text>

                      <Statistic
                        key={0}
                        title='Feminino'
                        graph={{
                          value: 2000 / 2400.90,
                          color: '#64C680',
                        }}
                        label={{
                          value: 2000,
                          formatter: 'decimal',
                          precision: 0,
                        }}
                      />

                      <Statistic
                        key={1}
                        title='Masculino'
                        graph={{
                          value: 200 / 2400.90,
                          color: '#DD7033',
                        }}
                        label={{
                          value: 200,
                          formatter: 'decimal',
                          precision: 0,
                        }}
                      />
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </Layer>
      )}
    </ResponsiveContext.Consumer>
  );
}

const mapStateToProps = ({
  layerReducer,
 }) => ({
  //id: formCreateUpdateCopyGeneric.id,

  toggleLayer: layerReducer.toggleLayer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    toggleInsightsLayer,
  }, dispatch);

export const Insights = connect(mapStateToProps, mapDispatchToProps)(InsightsAmendment);
